import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="job-type-form"
export default class extends Controller {
  static targets = ["radio", "submitButton"]

  connect() {
    this.updateSubmitButton()
  }

  selectJobType() {
    this.updateSubmitButton()
    
    // Store selected job type in localStorage for future use
    const selectedJobType = this.radioTargets.find(radio => radio.checked)
    if (selectedJobType) {
      localStorage.setItem("selectedJobType", selectedJobType.value)
    }
  }

  updateSubmitButton() {
    const hasSelection = this.radioTargets.some(radio => radio.checked)
    this.submitButtonTarget.disabled = !hasSelection
  }

  submit(event) {
    event.preventDefault()
    
    const selectedJobType = this.radioTargets.find(radio => radio.checked)
    if (selectedJobType) {
      // In a real application, this would redirect to the registration flow
      console.log("Selected job type:", selectedJobType.value)
      // window.location.href = "/users/new"
    }
  }
}
